import { z } from "zod";

// Largest value a PostgreSQL int4 column can hold. Numeric database ids must
// stay within this bound or the query throws at the driver level.
export const PG_INT4_MAX = 2_147_483_647;

// Bounded numeric-id schema shared by every payload carrying a database int4
// id. `z.coerce.number()` coerces booleans (`true` -> 1) and other loose
// values, so we restrict the input type _before_ coercion: only a number or an
// all-digit string is accepted. Rejects booleans, objects, UUIDs, fractions,
// negatives, zero, and out-of-range values.
export const dbIntIdSchema = z.preprocess(
    (value) =>
        typeof value === "number" ||
        (typeof value === "string" && /^\d+$/.test(value))
            ? value
            : NaN,
    z.coerce.number().int().min(1).max(PG_INT4_MAX),
);

// `.url()` alone is not enough: it is backed by `new URL()`, which accepts
// `javascript:` / `data:` schemes, so we additionally require `https:`.
export const httpsUrlSchema = z
    .string()
    .url()
    .refine(
        (value) => {
            try {
                return new URL(value).protocol === "https:";
            } catch {
                return false;
            }
        },
        { message: "must be an https URL" },
    );
